import React from 'react';
import { useTranslation } from 'react-i18next';

import checkIcon from '../../../../assets/changeCoverage/check-white.svg';

import styles from '../css/WellnessOptionCard.module.css';
import { currencyFormat } from '../../../../services/utils';

const WellnessOptionCard = ({
  current = false,
  details = '',
  disabled = false,
  onSelect = () => { },
  price = '',
  selected = false,
  title = '',
}) => {
  const { t } = useTranslation('changeCoverage');

  return (
    <div
      className={styles.wellnessCard}
      data-selected={selected}
    >
      <div className={styles.wellnessCardTitleRow}>
        <h4>{title}</h4>

        {current && (
          <span className={styles.wellnessCardCurrentTag}>
            {t('options.orca.current')}
          </span>
        )}
      </div>

      <p>{details}</p>

      <div className={styles.wellnessCardFooter}>
        <span>{currencyFormat({ value: price })}/mo</span>

        {selected ? (
          <span className={styles.wellnessCardSelected}>
            <img alt="" src={checkIcon} />

            {t('options.orca.selected')}
          </span>
        ) : (
          <div
            className={styles.wellnessCardSelectWrapper}
            data-tooltip={disabled
              ? t('options.orca.wellnessUpgradeDisabled') : undefined}
          >
            <button
              className={styles.wellnessCardSelectButton}
              disabled={disabled}
              onClick={onSelect}
              type="button"
            >
              {t('options.orca.select', { name: title })}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export { WellnessOptionCard };
